import { render, staticRenderFns } from "./intentionAnalysis.vue?vue&type=template&id=4f08d2c6&scoped=true"
import script from "./intentionAnalysis.vue?vue&type=script&lang=js"
export * from "./intentionAnalysis.vue?vue&type=script&lang=js"
import style0 from "./intentionAnalysis.vue?vue&type=style&index=0&id=4f08d2c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f08d2c6",
  null
  
)

export default component.exports